var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 12 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required|max:6" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "N° do Ofício:", required: true }
                        }),
                        _c(
                          "el-input",
                          {
                            staticClass: "input",
                            class: { erro: errors.length },
                            attrs: {
                              onkeypress: _vm.onlyInputNumbers,
                              disabled: _vm.isMatricula
                            },
                            model: {
                              value: _vm.numeroOficio,
                              callback: function($$v) {
                                _vm.numeroOficio = $$v
                              },
                              expression: "numeroOficio"
                            }
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "append" }, slot: "append" },
                              [_vm._v(_vm._s(_vm.oficioSuffix))]
                            )
                          ]
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          !_vm.isMatricula
            ? _c(
                "el-col",
                { staticClass: "container-input", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Data de Emissão do Ofício:",
                      required: true
                    }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.dataEmissao,
                      callback: function($$v) {
                        _vm.dataEmissao = $$v
                      },
                      expression: "dataEmissao"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isMatricula
            ? _c(
                "el-col",
                { staticClass: "container-input", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: { label: "Nome do cartório:", required: true }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.oficio.cartorio.nome,
                      callback: function($$v) {
                        _vm.$set(_vm.oficio.cartorio, "nome", $$v)
                      },
                      expression: "oficio.cartorio.nome"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isMatricula
            ? _c(
                "el-col",
                { staticClass: "container-input", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: { label: "Município:", required: true }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.municipioNome,
                      callback: function($$v) {
                        _vm.municipioNome = $$v
                      },
                      expression: "municipioNome"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87cd8586", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87cd8586","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppDadosOficio.vue
// module id = null
// module chunks = 